export default __webpack_public_path__ + "static/media/image17.c57417dd.jpg";